export const multiFamilyBuildingTypeIds: string[] = ['low-rise-apartment', 'mid-rise-apartment', 'luxury-apartment', 'high-rise-apartment'];

export const isMultiFamilyProperty = (
  property?: { billingTypeId?: number | null, buildingTypeId?: string | null } | null,
): boolean => {
  if (!property) return false;

  return property.billingTypeId === 2 || multiFamilyBuildingTypeIds.includes(property.buildingTypeId ?? '');
};
